import React, {FC, forwardRef, ReactElement} from 'react';

import Dialog from '@mui/material/Dialog';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Fade from '@mui/material/Fade';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

import {TransitionProps} from '@mui/material/transitions';

import {PANEL_WIDTH} from '@/config';

type AboutPanelProps = {
  isOpen: boolean,
  severity: 'success' | 'error',
  messages: Array<string>,
  onClose: () => void
}

const Transition = forwardRef<unknown, TransitionProps & { children: ReactElement }>(
  (props, ref) => <Fade ref={ref} {...props}/>
);

Transition.displayName = 'Transition';

const AlertModal: FC<AboutPanelProps> = ({isOpen, severity, messages, onClose}) => {

  return <Dialog
    open={isOpen}
    slots={{transition: Transition}}
    keepMounted
    maxWidth={false}
    fullWidth={true}
    onClose={onClose}
    slotProps={{
      paper: {
        sx: {
          width: PANEL_WIDTH.alert,
          bgcolor: severity === 'success' ? '#aafccb' : '#f9bfbf'
        },
      },
    }}
  >
    <DialogContent>
      <DialogContentText component="div">
        <Stack direction="row" sx={{gap: 1, justifyContent: 'center'}}>
          {severity === 'success' && <CheckCircleIcon sx={{color: 'success.main'}}/>}
          {severity === 'error' && <ErrorIcon sx={{color: 'error.main'}}/>}
          <Typography sx={{fontStyle: 'italic'}}>
            {messages.map((message, index) => (
              <React.Fragment key={index}>
                {index > 0 && <br/>}
                {message}
              </React.Fragment>
            ))}
          </Typography>
        </Stack>
      </DialogContentText>
    </DialogContent>
  </Dialog>;
};
export default AlertModal;
